var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paper',{attrs:{"title":_vm.tab.name,"body-class":"mt-0"}},[_c('div',{staticClass:"px-2 pb-1"},[_c('b-row',[_c('b-col',[_c('p',[_vm._v(" Here you will upload your file before starting the job. ")])])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }